<template>
  <div id="app">
    <slide></slide>
    <router-view/>
  </div>
</template>
<script>
import slide from "@/components/slide";
export default {
  name: 'App',

  components: {
    slide
  },

}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 14px;
}
body{margin: 0;padding:0}
</style>
